export default __webpack_public_path__ + "static/media/compare.8d0f9c68.svg";